/// <amd-module name="Build/Admin/PoolsList/Flux" />
import { IVssPageContext } from "VSS/Platform/Context";

import { AgentCloudSource } from "Build/Admin/Common/Sources/AgentCloudSource";
import { AgentPoolSource } from "Build/Admin/Common/Sources/AgentPoolSource";
import { AgentQueueSource } from "Build/Admin/Common/Sources/AgentQueueSource";
import { JobSource } from "Build/Admin/Common/Sources/JobSource";
import { SecuritySource } from "Build/Admin/Common/Sources/SecuritySource";
import { ServiceEndpointSource } from "Build/Admin/Common/Sources/ServiceEndpointSource";
import { ActionsHub } from "Build/Admin/PoolsList/Actions/ActionsHub";
import { PoolsListActionCreator } from "Build/Admin/PoolsList/Actions/PoolsListActionCreator";
import { PoolCreationSource } from "Build/Admin/PoolsList/Sources/PoolCreationSource";
import { StoresHub } from "Build/Admin/PoolsList/Stores/StoresHub";

export class Flux {
    public actionsHub: ActionsHub;
    public agentCloudSource: AgentCloudSource;
    public agentPoolSource: AgentPoolSource;
    public agentQueueSource: AgentQueueSource;
    public jobSource: JobSource;
    public poolCreationSource: PoolCreationSource;
    public poolsListActionCreator: PoolsListActionCreator;
    public securitySource: SecuritySource;
    public serviceEndpointSource: ServiceEndpointSource;
    public storesHub: StoresHub;

    public constructor(pageContext: IVssPageContext) {
        this.actionsHub = new ActionsHub();
        this.agentCloudSource = new AgentCloudSource(pageContext);
        this.agentPoolSource = new AgentPoolSource(pageContext);
        this.agentQueueSource = new AgentQueueSource(pageContext);
        this.jobSource = new JobSource(pageContext);
        this.poolCreationSource = new PoolCreationSource(pageContext);
        this.securitySource = new SecuritySource(pageContext);
        this.serviceEndpointSource = new ServiceEndpointSource(pageContext);
        this.storesHub = new StoresHub(this.actionsHub);
        this.poolsListActionCreator = new PoolsListActionCreator({
            pageContext: pageContext,
            actionsHub: this.actionsHub,
            agentCloudSource: this.agentCloudSource,
            agentPoolSource: this.agentPoolSource,
            agentQueueSource: this.agentQueueSource,
            jobSource: this.jobSource,
            poolCreationSource: this.poolCreationSource,
            securitySource: this.securitySource,
            serviceEndpointSource: this.serviceEndpointSource,
            storesHub: this.storesHub
        });
    }

    public dispose(): void {
        this.poolsListActionCreator.dispose();
    }
}
